module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"product_option":"상품 옵션","positive":"만족해요","neutral":"무난해요","negative":"아쉬워요","expand_review":"리뷰 더보기","collapse_review":"리뷰 접기"}}')
  delete Component.options._Ctor
}
